/**
 * Telefon w modułach (DECISIONS 2026-10-17 [P] „Telefon: łatwy dostęp do całego menu” — moduły: pola dotyku ≥ 44 px,
 * dialogi pełnoekranowe, gdy są ciasne). Klasy dla elementów w `features/*`; komponenty bazowe (`ui/`) mają własne
 * rozmiary. Tylko na telefonie (`max-md:`), desktop bez zmian.
 */

/**
 * Większe pole dotyku bez zmiany układu: niewidoczny pseudo-element wychodzi poza przycisk (12 px w pionie, 4 px
 * w poziomie), więc link tekstowy 20 px („Dodaj”, „Zmień”, „Szczegóły”) ma na telefonie ok. 44 px wysokości.
 * Element musi mieć `position: relative` (dodawane tutaj) — nie łączyć z `absolute` / `fixed`.
 */
export const TOUCH_TEXT =
  "max-md:relative max-md:after:absolute max-md:after:-inset-x-1 max-md:after:-inset-y-3 max-md:after:content-['']";

/**
 * Przycisk 28–32 px (np. `Button size="s"`, ⋯ w wierszu): pole dotyku 44 px przez pseudo-element (8 px w pionie,
 * a przy samej ikonie także w poziomie). `Button` ma już `position: relative`.
 */
export const TOUCH_BUTTON =
  "max-md:after:absolute max-md:after:-inset-y-2 max-md:after:inset-x-0 max-md:after:content-['']";
export const TOUCH_ICON = "max-md:after:absolute max-md:after:-inset-2 max-md:after:content-['']";

/**
 * Jak `TOUCH_ICON` dla ikony 32 px przy prawej krawędzi kontenera z `overflow-x: auto` (np. „⋯” w ostatniej kolumnie
 * tabeli): pole rośnie tylko w lewo i w pionie, bo `::after` wystający w prawo poszerza obszar przewijania (tabela
 * Zespołu przewijała się o 4 px w bok).
 */
export const TOUCH_ICON_END =
  "max-md:after:absolute max-md:after:-inset-y-2 max-md:after:right-0 max-md:after:-left-3 max-md:after:content-['']";

/**
 * Jak `TOUCH_BUTTON`, ale na opakowaniu — dla przycisku z komponentu innego modułu bez `className` (np.
 * `NewTaskButton`, `AddTimeButton`): `<span className={TOUCH_CHILD_BUTTON}><NewTaskButton … /></span>`.
 */
export const TOUCH_CHILD_BUTTON =
  "max-md:[&>button]:after:absolute max-md:[&>button]:after:-inset-y-2 max-md:[&>button]:after:inset-x-0 max-md:[&>button]:after:content-['']";

/**
 * Dialog z długim formularzem na telefonie na cały ekran (zamiast okna z marginesem 16 px i przewijaniem
 * w środku): `<Dialog className={FULLSCREEN_ON_PHONE}>`. Desktop bez zmian (400–560 px).
 */
export const FULLSCREEN_ON_PHONE =
  'max-md:inset-0 max-md:top-0 max-md:left-0 max-md:h-dvh max-md:max-h-dvh max-md:w-full max-md:max-w-none max-md:translate-x-0 max-md:translate-y-0 max-md:rounded-none max-md:px-4 max-md:pt-5 max-md:pb-[calc(24px+env(safe-area-inset-bottom))]';

/**
 * `Segmented` (przełącznik widoku / zakładki nad listą) na telefonie: przyciski 40 px + obrys 2 px = pole 44 px.
 * `<Segmented className={SEGMENTED_TOUCH} … />`.
 */
export const SEGMENTED_TOUCH = 'max-md:[&>button]:h-10';
